import { FAQsContainer } from '@/components/Elements';
import { Head } from '@/components/Head';
import { PublicLayout } from '@/components/Layout';

export const Faqs = () => {
  return (
    <PublicLayout className="flex">
      <Head page="Faqs" />
      <FAQsContainer />
    </PublicLayout>
  );
};
